var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"configure-cart-item-name"},[_c('b-field',[_c('b-input',{attrs:{"placeholder":_vm.$t('checkout.configure.inputLabels.objectName')},model:{value:(_vm.fileName),callback:function ($$v) {_vm.fileName=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"fileName"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }